/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Temp access empty state alert icon
 *
 * @file TempAccessAlertIcon.jsx
 * @author Anuja Gaikwad
 * @since 2.3.4
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function TempAccessAlertIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40">
      <path
        d="M19.304 24.0919C18.972 24.0919 18.7 23.8199 18.7 23.4879V15.1479C18.7 14.8159 18.972 14.5439 19.304 14.5439C19.636 14.5439 19.908 14.8159 19.908 15.1479V23.4879C19.908 23.8199 19.636 24.0919 19.304 24.0919Z"
        fill="var(--temp-access-icon-accent, currentColor)"
      />
      <path
        d="M19.3039 25.5039C19.7599 25.5039 20.1359 25.8759 20.1359 26.3359C20.1359 26.7959 19.7639 27.1679 19.3039 27.1679C18.8439 27.1679 18.4719 26.7959 18.4719 26.3359C18.4719 25.8759 18.8439 25.5039 19.3039 25.5039ZM19.3039 26.3479C19.3039 26.3479 19.3159 26.3439 19.3159 26.3359C19.3159 26.3239 19.2919 26.3239 19.2919 26.3359C19.2919 26.3439 19.2959 26.3479 19.3039 26.3479Z"
        fill="currentColor"
      />
      <path
        d="M33.656 28.4999L22.972 9.99191C22.6 9.34391 21.984 8.91591 21.272 8.77991C20.8 8.10791 20.048 7.71191 19.216 7.71191C18.304 7.71191 17.484 8.18391 17.028 8.97591L6.34395 27.4839C5.88795 28.2759 5.88795 29.2199 6.34395 30.0079C6.71595 30.6559 7.33195 31.0839 8.04395 31.2199C8.51595 31.8919 9.26795 32.2879 10.1 32.2879H31.472C32.384 32.2879 33.204 31.8159 33.66 31.0239C34.116 30.2319 34.116 29.2879 33.66 28.4999H33.656ZM7.38795 29.4039C7.14795 28.9919 7.14795 28.4999 7.38795 28.0879L18.072 9.57991C18.308 9.16791 18.736 8.91991 19.212 8.91991C19.688 8.91991 20.112 9.16391 20.352 9.57991L31.036 28.0879C31.272 28.4999 31.272 28.9919 31.036 29.4039C30.796 29.8159 30.372 30.0639 29.896 30.0639H8.52795C8.05195 30.0639 7.62795 29.8159 7.38795 29.4039Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default TempAccessAlertIcon;
